// extracted by mini-css-extract-plugin
export var aboutCompany = "footer-module--about_company--Ec-Zd";
export var copyright = "footer-module--copyright--aObl1";
export var footer = "footer-module--footer--Z1xkR";
export var linkbutton = "footer-module--linkbutton--Diz9H";
export var links = "footer-module--links--LTQh5";
export var location = "footer-module--location--Ypi5Z";